import { motion } from 'motion/react';

export const FadeIn = (props: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <motion.div
      {...(props as any)}
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.22, ease: 'easeInOut' }}
    />
  );
};
